module.exports = __webpack_public_path__ + "img/screen.f28d9714.png";